/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetTab {
    getFixupPrototypeFunction() { return WidgetTab.fixupPrototype; }

    static newInstance(model: Partial<WidgetTab>): WidgetTab {
        let obj = Object.assign(new WidgetTab(), model);
        WidgetTab.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetTab>): WidgetTab {
        if (!model) return null;
        return WidgetTab.newInstance(<WidgetTab> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetTab) {
        if (!obj) return;

        models.WidgetTab.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetTab): boolean {
        Object.setPrototypeOf(obj, WidgetTab.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.widget) {
            models.WidgetComposition.fixupPrototype(this.widget);
        }
    }

    label: string;

    widget: models.WidgetComposition;

}
